
import * as React from "react"
import * as ReactDOM from "react-dom"
import { TestState } from "./common"
import { checkCoordinatorAccess } from "./controller-request"
import { DetailedTestGroup } from "../visual/detailery"
import { ConnectionTest, ConnectionTestGroup } from "../visual/domutils"
import { FriendlyTestBanner, RetestButton, SubmitReportButton } from "../visual/friendly"

/* The top-level group of tests. This implements TestGroup, but not TestDisplayer. */
class TopGroup {
    subtests: Array<ConnectionTest | ConnectionTestGroup>
    element: HTMLDivElement
    queueRerender: () => void;

    constructor(elt: HTMLDivElement) {
        this.subtests = []
        this.element = elt

        let me = this
        this.queueRerender = ( () => { me.rerender() } )
    }

    addChild(newChild:ConnectionTest | ConnectionTestGroup) {
        this.subtests.push(newChild)
        this.queueRerender()
    }

    rerender() {
        let friendly = React.createElement(FriendlyTestBanner, { tests: this.subtests })
        let retest = React.createElement(RetestButton)
        let detailed = React.createElement(DetailedTestGroup, { tests: this.subtests })
        let hr = React.createElement('hr')
        let report = React.createElement(SubmitReportButton, { tests: this.subtests })
        let ui = React.createElement(React.Fragment, null, friendly, retest, detailed, hr, report)
        ReactDOM.render(ui, this.element)
    }
}

/* The entry point, called on page load */
function beginTest() {
    var top = new TopGroup(document.getElementById('progressbox')! as HTMLDivElement);

    (window as any).TOP_GROUP = top;
    const hostname = window.location.host;

	if (hostname !== "") {
        top.addChild({
            identifier: '-page-',
            status: TestState.Ok,
            short: 'Page Load',
            summary: [ "We can connect to “", { elt: 'tt', cls: 'hostname', value: hostname }, "”." ]
        })
    }

    top.addChild({
        identifier: '-js-',
        status: TestState.Ok,
        short: 'JavaScript',
        summary: [ "We can execute Javascript." ]
    })

    checkCoordinatorAccess(top)
}

export { beginTest }
